export default __webpack_public_path__ + "locales/sl/JavascriptSdk.json?hash=b0338e6a04bad536693021f0c05e0681";